export default function isInViewport(node) {
  if (!node || typeof node.getBoundingClientRect !== 'function') return false;
  var dims = node.getBoundingClientRect();
  if (dims.left > window.innerWidth) return false; // à droite de l'écran
  if (dims.left < -dims.width) return false; // à gauche de l'écran

  if (dims.top > window.innerHeight) return false; // sous l'écran
  if (dims.top < -dims.height) return false; // au dessus de l'écran

  return true;
}
